import { CIVIL_STATUSES, REQUIRES_SPOUSE_DATA } from '../../constants/civil-status';

export const ENDORSEMENT_REQUIRED_FIELDS = [
  'label',
  'name',
  'rut',
  'nationality',
  'civilStatus',
  'profession',
  'address',
  'email',
  'personeriaComments',
];

export const ENDORSEMENT_SPOUSE_REQUIRED_FIELDS = [
  'spouceLabel',
  'spouceName',
  'spouceRut',
  'spouceNationality',
  'spouceProfession',
  'spouceAddress',
  'spouceEmail',
];

export const EMPTY_ENDORSEMENT_DEFAULTS = {
  label: 'SR',
  name: '',
  rut: '',
  nationality: 'chileno',
  profession: '',
  civilStatus: CIVIL_STATUSES.SINGLE,
  address: '',
  email: '',
  mainDisabled: false,
  spouceName: '',
  spouceLabel: 'SRA',
  spouceRut: '',
  spouceAddress: '',
  spouceNationality: '',
  spouceProfession: '',
  personeriaComments: '',
  spouceEmail: '',
};

export const createEmptyEndorsement = () => ({
  id: Date.now(),
  ...EMPTY_ENDORSEMENT_DEFAULTS,
});

export const isEndorsementComplete = (endorsement) => {
  const baseComplete = ENDORSEMENT_REQUIRED_FIELDS.every(
    (field) => String(endorsement?.[field] ?? '').trim() !== '',
  );

  if (!REQUIRES_SPOUSE_DATA.includes(endorsement.civilStatus)) {
    return baseComplete;
  }

  return baseComplete && ENDORSEMENT_SPOUSE_REQUIRED_FIELDS.every(
    (field) => String(endorsement?.[field] ?? '').trim() !== '',
  );
};
